module.exports = __webpack_public_path__ + "static/2-c6ad781347cdcaeb2110ffad69949a61.png";